var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockFilled2Gold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06813 4.30824H8.66438V2.70405C8.66448 1.21448 7.01848 0 5.00003 0C2.98158 0 1.33541 1.21456 1.33541 2.70424V4.30844H0.931659C0.403754 4.30844 0 4.60638 0 4.99594L0.00010398 10.3125C0.00010398 10.7021 0.403858 11 0.931763 11H9.06834C9.59625 11 10 10.7021 10 10.3125L9.9999 4.99575C9.9999 4.62913 9.56516 4.30824 9.06824 4.30824H9.06813ZM5.4658 7.67701V8.70826C5.4658 8.89157 5.24838 9.05201 4.99997 9.05201C4.75157 9.05201 4.53415 8.89157 4.53415 8.70826V7.67701C4.22356 7.53951 4.00624 7.31031 4.00624 7.01245C4.00624 6.59995 4.47207 6.25619 5.03107 6.25619C5.59006 6.25619 6.05589 6.59995 6.05589 7.01245C6.0248 7.28745 5.80738 7.53951 5.4658 7.67701ZM2.73285 4.30824V2.70405C2.73285 1.78735 3.75767 1.0311 4.99992 1.0311C6.24217 1.0311 7.26699 1.78735 7.26699 2.70405V4.30824H2.73285Z",
    fill: "url(#paint0_linear_3545_2232)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3545_2232",
    x1: 5.6832e-8,
    y1: -1.52778,
    x2: 7.01015,
    y2: 12.5654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8655"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFilled2Gold);
export default __webpack_public_path__ + "static/media/lock-filled2-gold.54f820165333e046d845edd97eab2ddb.svg";
export { ForwardRef as ReactComponent };